import React from 'react';

import { FormatGroupsProps } from './FormatGroups.types';
import { Info } from './FormatGroups.styles';
import { TextElement } from '@ibinder/common-frontend';
import { GeneralPrint } from '../GeneralPrint';

export const FormatGroups: React.FC<FormatGroupsProps> = ({
  printProvider,
  printSettings,
  updateManually
}) => {
  return (
    <>
      <Info>
        <TextElement color="discrete70" fontStyle="extraSmallFont">
          Please specify format groups that will be available for printing
          Drawings.
        </TextElement>
      </Info>
      <GeneralPrint
        type="formatGroups"
        printProvider={printProvider}
        printSettings={printSettings}
        dataKey="drawingPrintSettings"
        updateManually={updateManually}
      />
    </>
  );
};
